export const INITIAL_STATE = {
  selections: {
    Role: {
      Role: [],
    },
    Expertise: {
      'Functional Area': ['Clinical Operations'],
      'Therapeutic Areas': [],
      'Product Technologies': [],
      Diseases: [],
      'Phases of Development': [],
      Industries: [],
      Keyword: null,
    },
    Seniority: {
      'Years of Experience': [],
      'Seniority Level': [],
    },
    'Work Preferences': {
      'Hourly Rate': [],
      Location: [],
      Languages: [],
      Availability: false,
    },
  },
};
export const tempRefs = [{
  name: 'Role',
  parent: 'Role',
  key: 'role',
}, {
  name: 'Functional Area',
  parent: 'Expertise',
  key: 'functional_areas',
}, {
  name: 'Therapeutic Areas',
  parent: 'Expertise',
  key: 'therapeutic_areas',
}, {
  name: 'Product Technologies',
  parent: 'Expertise',
  key: 'therapies',
}, {
  name: 'Diseases',
  parent: 'Expertise',
  key: 'diseases',
}, {
  name: 'Phases of Development',
  parent: 'Expertise',
  key: 'phases_of_development',
}, {
  name: 'Industries',
  parent: 'Expertise',
  key: 'industries',
}, {
  name: 'Keyword',
  parent: 'Expertise',
  key: 'keyword',
}, {
  name: 'Years of Experience',
  parent: 'Seniority',
  key: 'years_of_experience',
}, {
  name: 'Seniority Level',
  parent: 'Seniority',
  key: 'seniority_levels',
}, {
  name: 'Hourly Rate',
  parent: 'Work Preferences',
  key: 'hourly_rates',
}, {
  //   name: 'Location',
  //   key: 'location',
  // }, {
  name: 'Languages',
  parent: 'Work Preferences',
  key: 'languages',
},
{
  name: 'Availability',
  parent: 'Work Preferences',
  key: 'available_now',
}];
export const MENU_ITEMS = ['Role', 'Expertise', 'Seniority', 'Work Preferences'];
export const SELECT_INPUTS = ['Role', 'Therapeutic Areas', 'Product Technologies'];
export const ASYNC_INPUTS = ['Diseases', 'Languages'];
export const SLIDER_INPUTS = ['Years of Experience', 'Hourly Rate'];
export const CHECKBOX_INPUTS = ['Availability'];
export const GEOFILTER_INPUTS = ['Location'];
export const TEXT_INPUTS = ['Keyword'];
